import FeatherIcon from "feather-icons-react";
import PropTypes from 'prop-types'
import IconComponent from '../button/IconComponent';

const CardComponent = ({ titleName, iconName, data }) => {
    if (!data || data.length === 0) return null; // Handle empty data

    return (
        <div className="bg-white shadow-lg rounded-xl mt-6 lg:mt-0 flex-1 px-5 border-l border-r border-gray-200 pt-5 lg:pt-0">
            {/* Header */}
            <div className="flex flex-col sm:flex-row items-center p-5 border-gray-200 dark:border-dark-5">
                {iconName && <IconComponent icon={iconName} color='gray' />} &nbsp;&nbsp;
                <h1>{titleName}</h1>
            </div>

            {/* Dynamic Details Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {data.map((item, index) => (
                    <div key={index} className="flex items-center p-1 bg-gray-10 rounded-lg shadow-sm transition-transform hover:scale-105 duration-200">
                        <FeatherIcon icon={item.icon} className="w-5 h-5 text-blue-600 mr-3" />
                        <div>
                            <div className="text-sm text-gray-500">{item.label}</div>
                            <div className="text-base font-medium text-gray-800">{item.value || "N/A"}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

// Define Prop Types
CardComponent.propTypes = {
    titleName: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
        })
    ).isRequired,
};

export default CardComponent;
